import { RouteMetadata } from './types';

export const templatesMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/templates/new',
        section: 'templates',
        view: 'create',
        descriptionTemplate: 'User is creating a new template',
        capabilities: [
            'Enter template name and description',
            'Add tags to categorize the template',
            'Configure initial template settings',
            'Save the new template',
        ],
        hints: [
            'Templates should have descriptive names',
            'Tags help organize and find templates',
            'Templates can be based on existing workflows',
        ],
    },
    {
        pattern: '/agents/:agentId/templates/:templateId/versions/:versionId',
        section: 'templates',
        view: 'version-details',
        descriptionTemplate: 'User is viewing version {versionId} of template {templateId}',
        capabilities: [
            'View template version details',
            'Edit template configuration',
            'Publish or unpublish the version',
            'Create new version from this version',
            'Delete the version',
        ],
        hints: [
            'Templates are reusable workflow configurations',
            'Each template can have multiple versions',
            'Versions can be published to make them available',
        ],
    },
    {
        pattern: '/agents/:agentId/templates/:templateId',
        section: 'templates',
        view: 'details',
        descriptionTemplate: 'User is viewing template {templateId}',
        capabilities: [
            'View template details',
            'Edit template metadata',
            'Manage template versions',
            'Create new version',
            'Delete the template',
        ],
        hints: [
            'Templates define reusable workflow patterns',
            'Templates can be instantiated into workflows',
            'Each template has a name, description, and tags',
        ],
    },
    {
        pattern: '/agents/:agentId/templates',
        section: 'templates',
        view: 'list',
        descriptionTemplate: 'User is viewing the templates list',
        capabilities: [
            'View all templates',
            'Create new templates',
            'Filter templates by tags',
            'Delete templates',
            'Search templates',
        ],
        hints: [
            'Templates are reusable workflow blueprints',
            'Templates can be shared across agents',
            'Each template shows its tags and version count',
        ],
    },
];
